module.exports = __webpack_public_path__ + "static/img/Tom-Trbojevic.3b70aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Trbojevic.jpg
// module id = qxL/
// module chunks = 0